import { gql } from '@apollo/client';

export const ParagraphActivityPoiNearActivitiesFragment = gql`
  fragment ParagraphActivityPoiNearActivities on ParagraphActivityPoiNearActivities {
    id
    title
  }
`;
